import {FormConfig} from '../../../models/form-config';
import {FieldType} from '../../../models/field-type';
import {Validator} from '../../../models/validator.enum';
import {InsurerDataConsts} from '../../../../core/consts/insurer-data.consts';
import {RegExpKey, RegExpService} from '../../../services/reg-exp.service';

export class SeparateInsurerDataSectionConfig {

    constructor(private regExpService: RegExpService) {

    }

    createConfig(): FormConfig {
        return {
            formKey: 'SEPARATE_INSURER_DATA_SECTION',
            fieldsConfig: [
                {
                    fieldKey: InsurerDataConsts.FIRST_NAME,
                    caption: 'OWNER_DATA_SECTION.FORM_FIELDS.firstName',
                    captionForPreview: 'OWNER_DATA_SECTION.FORM_FIELDS.firstName',
                    type: FieldType.TextField,
                    personalData: true,
                    displayInPreviewMode: true,
                    validators: [
                        Validator.REQUIRED,
                        {
                            name: Validator.PATTERN,
                            pattern: this.regExpService.getRegExp(RegExpKey.FIRST_NAME)
                        },
                        {
                            name: Validator.MAX_LENGTH,
                            maxLength: 100
                        },
                        {
                            name: Validator.MIN_LENGTH,
                            minLength: 2
                        }],
                    autocomplete: 'given-name',
                    properties: {
                        textTransform: {
                            type: 'capitalize'
                        },
                    }
                },
                {
                    fieldKey: InsurerDataConsts.LAST_NAME,
                    caption: 'OWNER_DATA_SECTION.FORM_FIELDS.lastName',
                    captionForPreview: 'OWNER_DATA_SECTION.FORM_FIELDS.lastName',
                    type: FieldType.TextField,
                    personalData: true,
                    displayInPreviewMode: true,
                    validators: [
                        Validator.REQUIRED,
                        {
                            name: Validator.PATTERN,
                            pattern: this.regExpService.getRegExp(RegExpKey.LAST_NAME)
                        },
                        {
                            name: Validator.MAX_LENGTH,
                            maxLength: 100
                        },
                        {
                            name: Validator.MIN_LENGTH,
                            minLength: 2
                        }],
                    autocomplete: 'family-name',
                    properties: {
                        textTransform: {
                            type: 'capitalize'
                        },
                    }
                },
                {
                    fieldKey: InsurerDataConsts.PESEL,
                    caption: 'OWNER_DATA_SECTION.FORM_FIELDS.pesel',
                    captionForPreview: 'OWNER_DATA_SECTION.FORM_FIELDS.pesel',
                    personalData: true,
                    displayInPreviewMode: true,
                    type: FieldType.TextField,
                    validators: [
                        Validator.REQUIRED,
                        Validator.PESEL,
                        Validator.LEGAL_AGE_PESEL
                    ],
                    maskConfig: {
                        mask: '00000000000'
                    },
                    properties: {
                        mobileInputType: 'tel',
                    }
                },
                {
                    fieldKey: InsurerDataConsts.POSTAL_CODE,
                    caption: 'OWNER_DATA_SECTION.FORM_FIELDS.postalCode',
                    type: FieldType.TextField,
                    displayInPreviewMode: true,
                    validators: [
                        Validator.REQUIRED_NOT_BLANK,
                        Validator.POSTAL_CODE,
                        {
                            name: Validator.PATTERN,
                            pattern: this.regExpService.getRegExp(RegExpKey.POSTAL_CODE)
                        }],
                    maskConfig: {
                        mask: '00-000',
                        dropSpecialCharacters: false
                    },
                    autocomplete: 'postal-code',
                    properties: {
                        mobileInputType: 'tel',
                    },
                    analyticsConfig: {
                        includeFieldValue: true
                    }
                },
                {
                    fieldKey: InsurerDataConsts.CITY,
                    caption: 'INSURER_DATA_SECTION.FORM_FIELDS.city',
                    type: FieldType.TextField,
                    autocomplete: 'address-level2',
                    validators: [
                        Validator.REQUIRED,
                        {
                            name: Validator.PATTERN,
                            pattern: this.regExpService.getRegExp(RegExpKey.CITY)
                        },
                        {
                            name: Validator.MAX_LENGTH,
                            maxLength: 100
                        },
                        {
                            name: Validator.MIN_LENGTH,
                            minLength: 0
                    }],
                    properties: {
                        textTransform: {
                            type: 'capitalize'
                        }
                    },
                    analyticsConfig: {
                        includeFieldValue: true
                    }
                },
                {
                    fieldKey: InsurerDataConsts.STREET,
                    caption: 'INSURER_DATA_SECTION.FORM_FIELDS.street',
                    type: FieldType.TextField,
                    autocomplete: 'address-line1',
                    validators: [
                        Validator.REQUIRED,
                        {
                            name: Validator.MAX_LENGTH,
                            maxLength: 100
                        },
                        {
                            name: Validator.PATTERN,
                            pattern: this.regExpService.getRegExp(RegExpKey.STREET)
                        },
                        {
                            name: Validator.MIN_LENGTH,
                            minLength: 2
                    }],
                    properties: {
                        textTransform: {
                            type: 'capitalize'
                        }
                    },
                },
                {
                    fieldKey: InsurerDataConsts.BUILDING_NUMBER,
                    caption: 'INSURER_DATA_SECTION.FORM_FIELDS.buildingNumber',
                    type: FieldType.TextField,
                    validators: [
                        Validator.REQUIRED_NOT_BLANK,
                        {
                            name: Validator.PATTERN,
                            pattern: this.regExpService.getRegExp(RegExpKey.BUILDING_NUMBER)
                        },
                        {
                            name: Validator.MAX_LENGTH,
                            maxLength: 100
                        },
                        {
                            name: Validator.MIN_LENGTH,
                            minLength: 1
                        }],
                    autocomplete: 'address-line2',
                    properties: {
                        textTransform: {
                            type: 'capitalizeAndRemoveSpaces'
                        },
                    }
                },
                {
                    fieldKey: InsurerDataConsts.FLAT_NUMBER,
                    caption: 'INSURER_DATA_SECTION.FORM_FIELDS.flatNumber',
                    type: FieldType.TextField,
                    validators: [
                        {
                            name: Validator.PATTERN,
                            pattern: this.regExpService.getRegExp(RegExpKey.FLAT_NUMBER)
                        },
                        {
                            name: Validator.MAX_LENGTH,
                            maxLength: 100
                        },
                        {
                            name: Validator.MIN_LENGTH,
                            minLength: 1
                        }],
                    autocomplete: 'address-line3',
                    properties: {
                        textTransform: {
                            type: 'capitalizeAndRemoveSpaces'
                        },
                    }
                }
            ]
        };
    }

}
